import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import IconRight from 'assets/images/rates-logo.svg';

import RateCard from './RateCard';
import styles from './styles.scss';
import Switch from './Switch';
import Select from './Select';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

const options1 = [
  'Корпоративный доступ для агентств недвижимости',
  'Кабинет администратор компании для управления сотрудниками',
  'Подборки для клиентов в фирменном стиле компании',
];

const options2 = [
  'Индивидуальный доступ для частного агента по недвижимости',
  'Одновременный доступ на 2 устройствах',
  'Отправка персонализированных подборок клиентам',
];

const data = {
  0: {
    title: 'Для агенств',
    periods: {
      0: 'На 1 месяц',
      1: 'На 6 месяцев',
      2: 'На 12 месяцев',
    },
    cards: {
      'До 10 людей': {
        0: {
          price: '10 000 ₽',
          discount: '',
          altPrice: '',
        },
        1: {
          price: '48 000 ₽',
          discount: '',
          altPrice: '',
        },
        2: {
          price: '96 000 ₽',
          discount: '',
          altPrice: '',
        },
      },
      'Для 10-30 людей': {
        0: {
          price: '15 000 ₽',
          discount: '',
          altPrice: '',
        },
        1: {
          price: '72 000 ₽',
          discount: '20%',
          altPrice: '90 000 ₽',
        },
        2: {
          price: '144 000 ₽',
          discount: '20%',
          altPrice: '180 000 ₽',
        },
      },
      'Для 30+ людей': {
        0: {
          price: '20 000 ₽',
          discount: '',
          altPrice: '',
        },
        1: {
          price: '96 000 ₽',
          discount: '20%',
          altPrice: '120 000 ₽',
        },
        2: {
          price: '192 000 ₽',
          discount: '20%',
          altPrice: '240 000 ₽',
        },
      },
    },
    options: options1,
  },
  1: {
    title: 'Для агентов',
    periods: {
      0: 'Нет',
    },
    cards: {
      'Для 1 агента': {
        0: {
          price: '2 000 ₽/мес',
          discount: '',
          altPrice: '',
        },
      },
    },
    options: options2,
  },
};

const types = Object.keys(data).reduce((acc, key) => {
  acc[key] = data[key].title;

  return acc;
}, {});

const Rates = () => {
  const [type, setType] = useState(0);
  const [period, setPeriod] = useState(0);
  const [cards, setCards] = useState([]);
  const { t } = useTranslation();

  const handleSetType = (value) => {
    if (value === type) {
      return;
    }

    setType(value);
    setPeriod(0);
  };

  useEffect(() => {
    const nextCards = Object.keys(data[type].cards).map((title) => ({
      title,
      options: data[type].options,
      ...data[type].cards[title][period],
    }));
    setCards(nextCards);
  }, [type, period]);

  return (
    <div className={styles.WrapperContainer}>
      <style dangerouslySetInnerHTML={{ __html: 'html { background: #E8E9EB; }' }} />
      <div className={styles.Container}>
        <div className={styles.Header}>
          <Link to="/">
            <img src={IconRight} alt="" />
          </Link>
        </div>
        <div className={styles.Title}>Тарифы Nedvex</div>
        <Switch value={type} onChange={handleSetType} options={types} />
        {data[type].periods[1] !== undefined && (
          <Select value={period} onChange={setPeriod} options={data[type].periods} />
        )}
        <div className={styles.Tariffs}>
          {cards.map((card) => (
            <RateCard key={card.title + period + type} {...card} />
          ))}
        </div>
        <div className={styles.Footer}>
          <div className={cn(styles.SubGroup, styles.SubGroup1)}>
            <div dangerouslySetInnerHTML={{ __html: t('containers.login.footer1') }} />
          </div>
          <div className={cn(styles.SubGroup, styles.SubGroup2)}>
            <a
              href="https://nedvex.ru/%D0%90%D1%80%D1%85%D0%B8%D0%B2.zip"
              target="_blank"
              dangerouslySetInnerHTML={{ __html: t('containers.login.footer2') }}
            />
          </div>
          <div className={cn(styles.SubGroup, styles.SubGroup3)}>
            <div style={{ textAlign: 'center' }}>
              {t('containers.login.footer3')}
              <br />
              <a href="https://app.nedvex.ru/policy" target="_blank">
                {t('containers.login.docs')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rates;



// WEBPACK FOOTER //
// ./src/containers/Rates/index.js